import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

/***
 * @param {string[]} tabRoutes
 * @returns {{onTabChanged: Function, tabIndex: number}}
 */
const useTabsRouter = (tabRoutes) => {
  const [tabIndex, setTabIndex] = useState(0);
  const history = useHistory();
  /** @type {String} */
  const location = history.location.pathname;

  /**
   * @param {*} _
   * @param {Number} newValue
   */
  const onTabChanged = (_, newValue) => {
    history.push(tabRoutes[newValue]);
  };

  useEffect(() => {
    let tabIndex_ = -1;
    tabRoutes.forEach((tabRoute, i) => {
      if (i === 0) {
        if (
          location === "/" ||
          location.startsWith("/branches") ||
          location.startsWith("/decks") ||
          location.startsWith("/learn")
        ) {
          tabIndex_ = i;
        }
      } else {
        if (location === tabRoute || (tabRoute !== "/" && location.startsWith(tabRoute))) {
          tabIndex_ = i;
        }
      }
    });
    if (tabIndex_ > -1) {
      setTabIndex(tabIndex_);
    } else {
      // Если путь не соответствует ни одному табу - активных табов нет
      setTabIndex(false);
    }
  }, [location, tabRoutes]);

  return {
    onTabChanged,
    tabIndex,
  };
};

export default useTabsRouter;
